import { render, staticRenderFns } from "./TagCategories.vue?vue&type=template&id=529f673c&"
import script from "./TagCategories.vue?vue&type=script&lang=js&"
export * from "./TagCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports